/*
 *  I01DEPBOUCECSI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-20 16:58:47 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I01DEPBOUCECS_SECTION_0_TITLE: 'Calculez vos boucles et collecteurs ECS',
  I01DEPBOUCECS_SECTION_0_TITLE_MAIL: 'Conduite de départ',
  I01DEPBOUCECS_I10DIABOUCECS: 'Diamètre départ ECS',
  I01DEPBOUCECS_tube_dep_uuid_mail: 'DN départ',
  I01DEPBOUCECS_tube_dep_uuid: 'Diam. Ext: ',
  I01DEPBOUCECS_tube_dep_uuid2: 'mm, Ep.:',
  I01DEPBOUCECS_res_condthermique: 'Conductivité thermique',
  I01DEPBOUCECS_in_temp_dep_boucleECS: 'Température départ',
  I01DEPBOUCECS_in_temp_dep_moyenne_ambiance: 'Température ambiante',
  I01DEPBOUCECS_in_dep_epaisseur: 'Epaisseur',
  I01DEPBOUCECS_in_dep_long_tuyauterie: 'Longueur',
  I01DEPBOUCECS_in_dep_boucle_ailee: 'Débit bouclage',
  I01DEPBOUCECS_pdcUnitSelected_uuid: 'Unité calcul pertes de charges: ',
  I01DEPBOUCECS_SECTION_1_TITLE: '',
  I01DEPBOUCECS_SECTION_1_TITLE_MAIL: 'Résultats boucle départ',
  I01DEPBOUCECS_res_dep_puiss_par_m: 'Puissance par mètre',
  I01DEPBOUCECS_res_dep_puiss_nec_conduite: 'Puissance allé',
  I01DEPBOUCECS_res_dep_vitesse: 'Vitesse',
  I01DEPBOUCECS_res_dep_pdc: 'Pertes de charges',
  I01DEPBOUCECS_in_ret_epaisseur: 'Epaisseur',
  I01DEPBOUCECS_SECTION_2_TITLE: 'Conduite retour',
  I01DEPBOUCECS_in_ret_temp_ambiance: 'Température ambiante',
  I01DEPBOUCECS_in_ret_long_tuyauterie: 'Longueur',
  I01DEPBOUCECS_SECTION_3_TITLE: '',
  I01DEPBOUCECS_SECTION_3_TITLE_MAIL: 'Résultats boucle retour',
  I01DEPBOUCECS_tube_ret_uuid_mail: 'DN Retour',
  I01DEPBOUCECS_res_ret_puiss_par_m: 'Puissance par mètre',
  I01DEPBOUCECS_res_ret_puiss_nec_conduite: 'Puissance conduite',
  I01DEPBOUCECS_res_ret_vitesse: 'Vitesse',
  I01DEPBOUCECS_res_ret_pdc: 'Pertes de charges',
  I01DEPBOUCECS_SECTION_4_TITLE: 'Résultats boucle',
  I01DEPBOUCECS_res_total_deperdition: 'Déperditions',
  I01DEPBOUCECS_res_total_pdc: 'Perte de charge totale',
  I01DEPBOUCECS_res_ret_temp_fin_boucle: 'Température fin de boucle',
  I01DEPBOUCECS_dep_isolantSelected: 'Isolant',
  I01DEPBOUCECS_dep_isolantSelected_MAIL: "Type d'isolant"
}
